/**
 * Where an ask came from, for the small mark under his bubble (spec
 * 2026-09-24 §1). Read only from what the row says: a row that says nothing
 * (an old row, from before the server kept host and surface) gets no mark,
 * never a guessed "Web".
 */
import type { ComposerHistoryEntry } from "@/stores/composerHistoryStore";

export type SourceGlyph =
  "telegram" | "whatsapp" | "imessage" | "slack" | "voice" | "mac" | "web";

export interface Source {
  glyph: SourceGlyph;
  label: string;
}

/** The gateway channels, by the `surface` the gateway stamps. */
const CHANNELS = new Map<string, { glyph: SourceGlyph; label: string }>([
  ["telegram", { glyph: "telegram", label: "Telegram" }],
  ["whatsapp", { glyph: "whatsapp", label: "WhatsApp" }],
  ["imessage", { glyph: "imessage", label: "iMessage" }],
  ["slack", { glyph: "slack", label: "Slack" }],
]);

/** The Mac app's own asking surfaces (the desktop shell only). */
const MAC_SURFACES = new Set(["voice_card", "moment_card"]);

export function sourceOf(
  e: Pick<ComposerHistoryEntry, "surface" | "host" | "via">
): Source | null {
  const channel = e.surface ? CHANNELS.get(e.surface) : undefined;
  if (channel) {
    return e.via === "voice"
      ? { glyph: channel.glyph, label: `${channel.label} voice note` }
      : channel;
  }
  if (e.via === "voice") return { glyph: "voice", label: "Spoken" };
  if ((e.surface && MAC_SURFACES.has(e.surface)) || e.host === "native") {
    return { glyph: "mac", label: "Mac app" };
  }
  if (e.host === "web") return { glyph: "web", label: "Web" };
  return null;
}
